/** 작은 바이트 쓰기 도우미 (리틀 엔디언) */
export class ByteWriter {
  private buf: Uint8Array;
  pos = 0;
  constructor(size = 4096) {
    this.buf = new Uint8Array(size);
  }
  private ensure(n: number) {
    if (this.pos + n <= this.buf.length) return;
    let size = this.buf.length * 2;
    while (size < this.pos + n) size *= 2;
    const nb = new Uint8Array(size);
    nb.set(this.buf.subarray(0, this.pos));
    this.buf = nb;
  }
  u8(v: number) {
    this.ensure(1);
    this.buf[this.pos++] = v & 0xff;
  }
  i8(v: number) {
    this.u8(v < 0 ? v + 256 : v);
  }
  u16(v: number) {
    this.u8(v);
    this.u8(v >> 8);
  }
  u16be(v: number) {
    this.u8(v >> 8);
    this.u8(v);
  }
  u24(v: number) {
    this.u8(v);
    this.u8(v >> 8);
    this.u8(v >> 16);
  }
  i32(v: number) {
    this.ensure(4);
    new DataView(this.buf.buffer).setInt32(this.pos, v | 0, true);
    this.pos += 4;
  }
  f32(v: number) {
    this.ensure(4);
    new DataView(this.buf.buffer).setFloat32(this.pos, v, true);
    this.pos += 4;
  }
  bytes(b: ArrayLike<number>) {
    this.ensure(b.length);
    for (let i = 0; i < b.length; i++) this.buf[this.pos++] = b[i] & 0xff;
  }
  ascii(s: string) {
    for (let i = 0; i < s.length; i++) this.u8(s.charCodeAt(i) & 0x7f);
  }
  /** 이미 쓴 자리를 덮어쓴다 */
  patchU16(at: number, v: number) {
    this.buf[at] = v & 0xff;
    this.buf[at + 1] = (v >> 8) & 0xff;
  }
  patchU24(at: number, v: number) {
    this.buf[at] = v & 0xff;
    this.buf[at + 1] = (v >> 8) & 0xff;
    this.buf[at + 2] = (v >> 16) & 0xff;
  }
  patchI32(at: number, v: number) {
    new DataView(this.buf.buffer).setInt32(at, v | 0, true);
  }
  result(): Uint8Array {
    return this.buf.slice(0, this.pos);
  }
}

/** 파일 머리글에 넣을 수 있는 ASCII 이름 (한글 등은 빼고 대문자) */
export function asciiLabel(name: string, max: number): string {
  const s = name
    .normalize("NFKD")
    .replace(/[^A-Za-z0-9 _-]/g, "")
    .trim()
    .toUpperCase()
    .slice(0, max);
  return s || "JASU";
}
